export enum SpatialReferenceType {
    GEOGRAPHIC = 1,
    PROJECTED
}